<mat-toolbar class="mat-elevation-z8">
  Display Tests
</mat-toolbar>

<mat-dialog-content class="d-flex flex-column gap-3 content-dark">
  <a [href]="displayUrls[0] + '?id='+display.id" target="_blank" class="d-flex flex-row align-items-center gap-2">
    Prod <mat-icon>connected_tv</mat-icon> :
    <span>
      {{ display.name ? display.name : display.id }}
    </span>
  </a>
  <a [href]="displayUrls[1] + '?id='+display.id" target="_blank" class="d-flex flex-row align-items-center gap-2">
    Test <mat-icon>connected_tv</mat-icon> :
    <span>
      {{ display.name ? display.name : display.id }}
    </span>
  </a>
  <a [href]="displayUrls[2] + '?id='+display.id" target="_blank" class="d-flex flex-row align-items-center gap-2 mb-4">
    Local <mat-icon>connected_tv</mat-icon> :
    <span>
      {{ display.name ? display.name : display.id }}
    </span>
  </a>
  <h3 class="heading-dark">
    Statuses :
  </h3>
  <div class="d-flex flex-column gap-2">
    @for (status of statusList; track status) {
    <div>
      <button mat-button mat-raised-button class="test-btn"
        (click)="executeTest(status.url)">{{status.viewValue}}</button>
    </div>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions class="pe-4 py-3" align="end">
  <button mat-button mat-stroked-button color="primary" [disabled]="isLoading">
    {{ 'PRICING.FORM.CANCEL' | transloco }}
  </button>
</mat-dialog-actions>